import { render, staticRenderFns } from "./pipSelection.vue?vue&type=template&id=2427bfe9&scoped=true&"
import script from "./pipSelection.vue?vue&type=script&lang=js&"
export * from "./pipSelection.vue?vue&type=script&lang=js&"
import style0 from "./pipSelection.vue?vue&type=style&index=0&id=2427bfe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2427bfe9",
  null
  
)

export default component.exports